export default __webpack_public_path__ + "static/help@2x-1455cfa7a9c6669b7a220076b1c5e24e.png";